module.exports = __webpack_public_path__ + "img/banana.e5614ee2.svg";